import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import pt from "../../images/News/Pt.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";
import SpaceL from "../../commons/SpaceL";
import PtAccordionPrezzi from "../../components/palestra/PtAccordionPrezzi";

function PtNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={pt} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={pt} style={{width: "100%"}}></img>
            </div>
            <SpaceL/>
            <PtAccordionPrezzi />
            <Space/>
        </div>
    )
}
export default PtNews